import React from 'react';
import { MapPin } from 'lucide-react';
import { COMMUNITIES } from '../data/mock';

const provinceColor = {
  Gauteng: {
    bar: 'bg-[#2196F3]',
    chip: 'bg-[#E3F2FD] text-[#1565C0] border-[#90CAF9]',
    label: 'text-[#1565C0]',
  },
  'Western Cape': {
    bar: 'bg-[#EC407A]',
    chip: 'bg-[#FCE4EC] text-[#AD1457] border-[#F48FB1]',
    label: 'text-[#AD1457]',
  },
};

const Communities = () => {
  // Group by province
  const grouped = COMMUNITIES.reduce((acc, c) => {
    (acc[c.province] = acc[c.province] || []).push(c);
    return acc;
  }, {});

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-block px-4 py-1.5 bg-[#F55B26]/10 text-[#F55B26] font-semibold text-xs uppercase tracking-widest rounded-full mb-4">
            Where We Serve
          </div>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0B3B44] leading-tight mb-3">
            Six communities. <span className="text-[#F55B26]">One shared mission.</span>
          </h2>
          <p className="text-lg text-slate-600">
            From informal settlements to established townships, we bring warm plates and dignity to families across South Africa.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {Object.entries(grouped).map(([province, list]) => {
            const c = provinceColor[province] || provinceColor.Gauteng;
            return (
              <div
                key={province}
                className="relative bg-gradient-to-br from-white to-[#FFF7F1] rounded-3xl border border-slate-100 shadow-sm hover:shadow-lg transition-all overflow-hidden"
              >
                <div className={`absolute top-0 left-0 h-1 w-full ${c.bar}`} />
                <div className="p-7">
                  <div className="flex items-center gap-3 mb-5">
                    <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${c.chip} border`}>
                      <MapPin className="w-5 h-5" />
                    </div>
                    <div>
                      <div className={`text-[10px] uppercase tracking-wider font-bold ${c.label}`}>Province</div>
                      <div className="text-lg font-extrabold text-[#0B3B44]">{province}</div>
                    </div>
                    <div className="ml-auto text-2xl font-extrabold text-[#0B3B44]">
                      {list.length}
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2">
                    {list.map((item) => (
                      <span
                        key={item.name}
                        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border ${c.chip}`}
                      >
                        <span className={`w-1.5 h-1.5 rounded-full ${c.bar}`} />
                        {item.name}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Communities;
